if (!customElements.get("personalization-swatches")) {
  class ProductPersonalizationSwatches extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      this.option.textContent = event.target.value || '';
    }

    connectedCallback() {
      this.option = this.querySelector('.js-option-text');
      this.addEventListener("change", this.handleChange.bind(this));
    }
  }
  customElements.define("personalization-swatches", ProductPersonalizationSwatches);
}
